import { Component, computed, EventEmitter, input, Output, viewChild } from '@angular/core';
import { botBehaviorContent } from '../../helpers/assistant.content';
import { Experiences } from '@local/client-contracts';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DOMAIN_REGEX } from '@local/ts-infra';
import { UChipsComponent } from '@local/ui-infra';

@UntilDestroy()
@Component({
  selector: 'bot-behavior',
  templateUrl: './bot-behavior.component.html',
  styleUrls: ['../../base-preferences.scss', './bot-behavior.component.scss'],
})
export class BotBehaviorComponent {
  readonly botBehaviorContent = botBehaviorContent;
  readonly ITEM_ICON_STYLE = { fontSize: '12px', marginRight: '8px' };
  readonly DROPDOWN_STYLE = { width: '216px' };
  readonly CHIPS_STYLE = { width: '100%' };
  readonly chipsValidationRegex: RegExp = DOMAIN_REGEX;

  hasDomainError = computed(() => !this.chips()?.isValid());
  isValid = computed(() => this.chips()?.isValidAll());
  excludesDomains = computed(() => {
    if (this.originalAssistant()?.settings?.excludeDomains) {
      return this.originalAssistant().settings.excludeDomains?.map((value) => ({ value, isValid: true }));
    }
  });

  disabled = input();
  originalAssistant = input<Experiences.ExperienceItem<'slack'>>();
  assistant = input<Experiences.ExperienceItem<'slack'>>();
  @Output() updateData = new EventEmitter();
  chips = viewChild<UChipsComponent>('chips');

  onSensitiveDropDownChanged($event) {
    this.updateData.emit({ instructions: { ...this.originalAssistant()?.settings?.instructions, sensitivity: $event.value } });
  }

  excludeDomainsChanged(value) {
    const excludeDomains = value?.map((item) => item.value);
    this.updateData.emit({ excludeDomains });
  }

  onToggleActiveBotMessages(value) {
    this.updateData.emit({ replyBotMessages: value.checked });
  }
}
